import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Modal, Button, Alert, Spinner } from 'react-bootstrap';

/**
 * Blocking modal: explains subscription and starts WiPay flow when user is signed in.
 */
export default function PublicProductsSubscriptionModal({
  show,
  amount,
  currency,
  isLoggedIn,
  paying,
  errorMessage,
  onPay,
  onGoBack,
}) {
  const location = useLocation();

  return (
    <Modal show={show} onHide={() => {}} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Subscription required</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">
          Individual product analytics require an active subscription.
        </p>
        <p className="text-muted small mb-3">
          Complete a one-time payment of{' '}
          <strong>
            {currency} ${Number(amount).toFixed(2)}
          </strong>{' '}
          via WiPay to unlock detailed price, availability, and category insights.
        </p>
        {errorMessage && (
          <Alert variant="danger" className="py-2 small">
            {errorMessage}
          </Alert>
        )}
        {!isLoggedIn && (
          <Alert variant="info" className="py-2 small mb-0">
            Please{' '}
            <Link to="/login" state={{ from: location }}>
              sign in
            </Link>{' '}
            or create an account, then return here to pay.
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex flex-wrap gap-2 justify-content-between">
        <Button variant="outline-secondary" onClick={onGoBack} disabled={paying}>
          &larr; Go Back
        </Button>
        <Button variant="primary" onClick={onPay} disabled={paying || !isLoggedIn}>
          {paying ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Starting payment…
            </>
          ) : (
            'Pay with WiPay'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
